import CollapsibleItemBlock from './CollapsibleItemBlock';

export default CollapsibleItemBlock;
